/* Coria · 20.10.2026 (cerinta user): pe telefon, alegerea nuantei arata maxim 3 randuri (9 fise pe 3 coloane),
   apoi butonul „Vezi toate nuantele (+N)”. Clientele nu mai deruleaza la nesfarsit pana la „Adauga in cos”.
   Nuanta aleasa ramane mereu vizibila. Listele sunt redesenate de coria-product-choices (cautare, filtre),
   de aceea limita se reaplica la fiecare schimbare. */
(function () {
  'use strict';
  var MQ = window.matchMedia('all'); /* 20.10: limita se aplica si pe calculator (cerinta user: maxim 9) */
  var ROWS = 3;
  var SEL = 'coria-product-choices :is(.coria-shade-list, .coria-family-list)';
  var open = new WeakSet();

  function cols(list) {
    var t = getComputedStyle(list).gridTemplateColumns;
    var n = t && t !== 'none' ? t.split(' ').filter(Boolean).length : 1;
    return Math.max(1, n);
  }

  function btnFor(list) {
    var b = list.nextElementSibling;
    if (b && b.classList && b.classList.contains('cf-more-nuante')) return b;
    b = document.createElement('button');
    b.type = 'button';
    b.className = 'cf-more-nuante';
    b.addEventListener('click', function () {
      if (open.has(list)) { open.delete(list); apply(list); list.scrollIntoView({ block: 'nearest' }); }
      else { open.add(list); apply(list); }
    });
    list.after(b);
    return b;
  }

  /* 20.10.2026 (decizie user): in fisele familiei (ex. Marble Ink) aratam doar linia produsului deschis
     (pe Metallic doar Metallic, pe simplu doar simplu), fara dublura „Metallic 15ml” + „15 ml”. */
  function line(h) { return String(h || '').replace(/-\d+$/, ''); }
  function sameLine(list) {
    if (!list.classList.contains('coria-family-list')) return;
    var root = list.closest('coria-product-choices');
    var own = root && (root.dataset.selectedHandle || root.dataset.handle);
    var cur = line(own);
    /* doar produsele numerotate pe linii (ex. marble-ink-metallic-15ml-16); la uleiuri/cleanere (…-banane-15-ml) nu ascundem marimile */
    if (!cur || cur === own) return;
    Array.prototype.forEach.call(list.querySelectorAll('.coria-family-card'), function (card) {
      var sizes = Array.prototype.slice.call(card.querySelectorAll('.coria-family-size'));
      var mine = sizes.filter(function (b) { return line(b.dataset.handle) === cur; });
      sizes.forEach(function (b) { b.classList.toggle('cf-line-hide', mine.length > 0 && mine.indexOf(b) === -1); });
    });
  }

  /* cuvantul potrivit: la ulei/cleaner/spuma sunt arome, nu nuante */
  function kindOf(list) {
    if (list.classList.contains('coria-cleaner-aromas') || list.querySelector('.coria-aroma-option')) return ['aromele', 'arome'];
    var g = list.closest('.coria-choice-group, .coria-cleaner-selector');
    var h = g && g.querySelector('h3');
    var t = ((h && h.textContent) || '').toLowerCase();
    if (/arom/.test(t)) return ['aromele', 'arome'];
    if (/nuan/.test(t)) return ['nuantele', 'nuante'];
    if (/model/.test(t)) return ['modelele', 'modele'];
    return ['nuantele', 'nuante'];
  }

  /* 27.10: scriem textul/atributul doar daca s-a schimbat (altfel MutationObserver-ul reporneste scan la fiecare cadru) */
  function setTxt(b, t) { if (b.textContent !== t) b.textContent = t; }
  function setAttr(b, k, v) { if (b.getAttribute(k) !== v) b.setAttribute(k, v); }

  function apply(list) {
    sameLine(list);
    Array.prototype.forEach.call(list.querySelectorAll(':scope > .cf-more-hide'), function (el) { el.classList.remove('cf-more-hide'); });
    var items = Array.prototype.filter.call(list.children, function (el) {
      return el.matches('.coria-shade-option, .coria-family-card, .coria-aroma-option') && !el.hidden && getComputedStyle(el).display !== 'none';
    });
    var b = list.nextElementSibling && list.nextElementSibling.classList.contains('cf-more-nuante') ? list.nextElementSibling : null;
    if (!MQ.matches) { if (b) b.hidden = true; return; }
    /* lista veche cu paginare („Arata mai multe”, cate 12): pe telefon le incarcam pe toate, limita o face butonul nostru */
    var old = list.parentElement && list.parentElement.querySelector('.coria-choice-more');
    if (old && !old.hidden) { old.click(); return; }
    var c = cols(list);
    var max = c <= 3 ? c * ROWS : c * Math.max(1, Math.round(9 / c)); /* ~9 fise, pe randuri intregi */
    if (items.length <= max) { if (b) b.hidden = true; return; }
    b = btnFor(list);
    b.hidden = false;
    if (open.has(list)) {
      setTxt(b, 'Arata mai putine ' + kindOf(list)[1]);
      setAttr(b, 'aria-expanded', 'true');
      return;
    }
    var cur = items.findIndex(function (el) { return el.getAttribute('aria-pressed') === 'true' || el.classList.contains('is-current'); });
    var hidden = 0;
    items.forEach(function (el, i) {
      var keep = i < max || i === cur;
      if (cur >= max && i === max - 1) keep = false; /* locul ultimei fise il ia nuanta aleasa */
      if (!keep) { el.classList.add('cf-more-hide'); hidden++; }
    });
    setTxt(b, 'Vezi toate ' + kindOf(list)[0] + ' (+' + hidden + ')');
    setAttr(b, 'aria-expanded', 'false');
  }

  var queued = false;
  /* 27.10: numarul de coloane se stie abia dupa asezarea grilei -> reaplicam cand lista isi schimba marimea (inainte o facea, fara voie, bucla) */
  var ro = window.ResizeObserver ? new ResizeObserver(function (es) { /* doar latimea schimba numarul de coloane */
    var ch = false; es.forEach(function (e) { var w = Math.round(e.contentRect.width); if (lastW.get(e.target) !== w) { lastW.set(e.target, w); ch = true; } });
    if (ch) later();
  }) : null;
  var lastW = new WeakMap();
  function scan() {
    queued = false;
    document.querySelectorAll(SEL).forEach(function (list) {
      if (ro && !lastW.has(list)) { lastW.set(list, 0); ro.observe(list); }
      apply(list);
    });
  }
  function later() { if (!queued) { queued = true; requestAnimationFrame(scan); } }

  function start() {
    scan();
    /* 27.10: clasele puse de alte scripturi (ex. cfc-hide din coria-choices-plus, dupa prima numaratoare) schimba ce e vizibil;
       schimbarile facute de noi (cf-more-hide, cf-line-hide) nu reporneau nimic */
    function strip(c) { return String(c || '').replace(/\bcf-(more|line)-hide\b/g, '').replace(/\s+/g, ' ').trim(); }
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i], t = m.target;
        if (t.nodeType !== 1 || !(t.matches(SEL) || t.closest && t.closest('coria-product-choices'))) continue;
        if (m.type === 'attributes') {
          if (m.attributeName === 'class' && strip(m.oldValue) === strip(t.getAttribute('class'))) continue;
          if (!t.matches('.coria-shade-option, .coria-family-card, .coria-aroma-option')) continue;
        }
        later(); return;
      }
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeOldValue: true, attributeFilter: ['class', 'hidden'] });
    if (MQ.addEventListener) MQ.addEventListener('change', later);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
